import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { TokenService } from '../token/token.service';

// Requisições com este header não disparam logout em 401; o header é removido antes do envio.
export const SKIP_401_LOGOUT_HEADER = 'X-Skip-401-Logout';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const skipLogout = req.headers.has(SKIP_401_LOGOUT_HEADER);
  const outgoing = skipLogout
    ? req.clone({ headers: req.headers.delete(SKIP_401_LOGOUT_HEADER) })
    : req;

  return next(outgoing).pipe(
    catchError((err: unknown) => {
      if (
        err instanceof HttpErrorResponse &&
        err.status === 401 &&
        !skipLogout &&
        tokenService.hasToken()
      ) {
        tokenService.removeTokenAndLogout();
      }
      return throwError(() => err);
    }),
  );
};
